import { render, staticRenderFns } from "./PocAreaPlantadaGameleira.vue?vue&type=template&id=b2127a2c&lang=pug"
import script from "./PocAreaPlantadaGameleira.vue?vue&type=script&lang=js"
export * from "./PocAreaPlantadaGameleira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports